<template>
    <div>
        <h2>{{ step.title }}</h2>
        <p class="step__notice">
            All fields with an asterisk are required
            <i class="fas fa-asterisk"></i>
        </p>
        <p>
            We try our best to welcome everyone, no matter their circumstances
            or history. But we must make sure that everyone on our programmes is
            supported appropriately.
        </p>
        <p>
            <b
                >Please be honest and share as much information as you can - the
                more we understand the better we can help you.</b
            >
        </p>

        <InputRadioGroup
            name="have_criminal_record"
            :required="isRequired('have_criminal_record')"
            :error="form.errors.get('have_criminal_record')"
            v-model="form.have_criminal_record"
            :options="getField('have_criminal_record').options"
            @input="form.errors.clear('have_criminal_record')"
        >
            <template v-slot:question>
                {{ getField("have_criminal_record").question }}
            </template>
            <template v-slot:description>
                <small class="mb-3 d-block">
                    We have a responsibility to protect the people we work with,
                    please answer honestly as the answer you provide means we
                    will be able to support you in more appropriate ways.
                </small>
                <small class="d-block mb-3">
                    Not sure how to answer this question?
                    <a
                        href="https://www.gov.uk/tell-employer-or-college-about-criminal-record/check-your-conviction-caution"
                        target="_blank"
                    >
                        Check if you need to tell us this information
                    </a>
                </small>
            </template>
        </InputRadioGroup>

        <InputRadioGroup
            name="extra_skill_support_needed"
            :required="isRequired('extra_skill_support_needed')"
            :error="form.errors.get('extra_skill_support_needed')"
            v-model="form.extra_skill_support_needed"
            :options="getField('extra_skill_support_needed').options"
            @input="form.errors.clear('extra_skill_support_needed')"
        >
            <template v-slot:question>
                {{ getField("extra_skill_support_needed").question }}
            </template>
        </InputRadioGroup>

        <InputText
            v-if="form.extra_skill_support_needed === 'yes'"
            name="extra_skill_support_needed_more"
            :required="isRequired('extra_skill_support_needed_more')"
            :error="form.errors.get('extra_skill_support_needed_more')"
            v-model="form.extra_skill_support_needed_more"
            :is-multiline="true"
        >
            <template v-slot:question>
                {{ getField("extra_skill_support_needed_more").question }}
            </template>
        </InputText>

        <InputRadioGroup
            v-if="displayFieldForCourse('extra_computer_internet_support')"
            name="extra_computer_internet_support"
            :required="isRequired('extra_computer_internet_support')"
            :error="form.errors.get('extra_computer_internet_support')"
            v-model="form.extra_computer_internet_support"
            :options="getField('extra_computer_internet_support').options"
            @input="form.errors.clear('extra_computer_internet_support')"
        >
            <template v-slot:question>
                {{ getField("extra_computer_internet_support").question }}
            </template>
        </InputRadioGroup>

        <InputCheckboxGroup
            name="involved_in_services"
            :required="isRequired('involved_in_services')"
            :error="form.errors.get('involved_in_services')"
            v-model="form.involved_in_services"
            :options="getField('involved_in_services').options"
            :form="form"
            @textarea-updated="form[$event.field] = $event.value"
        >
            <template v-slot:question>
                {{ getField("involved_in_services").question }}
            </template>
            <template v-slot:description>
                {{ getField("involved_in_services").description }}
            </template>
        </InputCheckboxGroup>
    </div>
</template>

<script>
import InputText from "../Form/InputText";
import InputRadioGroup from "../Form/InputRadioGroup";
import InputCheckboxGroup from "../Form/InputCheckboxGroup";
import Form from "../../Form";
import { isRequired } from "./formHelper.js";

export default {
    name: "StepYourCircumstances",
    components: {
        InputText,
        InputRadioGroup,
        InputCheckboxGroup,
    },
    methods: {
        displayFieldForCourse(fieldName) {
            return this.getField(fieldName).applicable_courses.includes(
                this.course
            );
        },
        getField(fieldName) {
            return this.fields[fieldName];
        },
        isRequired(fieldName) {
            var fieldData = this.getField(fieldName);
            return isRequired(fieldData, this.form);
        },
    },
    data: function () {
        return {
            form: new Form(
                {
                    have_criminal_record: null,
                    extra_skill_support_needed: null,
                    extra_skill_support_needed_more: null,
                    extra_computer_internet_support: null,
                    involved_in_services: null,
                    all_social_involved_keyworker_text: null,
                    all_social_involved_other_text: null,
                    alcohol_drug_dependent: null,
                },
                this.formData
            ),
        };
    },
    props: {
        step: Object,
        fields: Object,
        formData: Object,
        course: String,
    },
};
</script>